// extracted by mini-css-extract-plugin
export var container = "styles-module__container____bii7";
export var select = "styles-module__select___nHtDA";
export var labelAndSelect = "styles-module__labelAndSelect___ybTYo";